import { styled, selectTheme, Typography } from '@creditas-ui/react'

const DocumentTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  align-self: center;
  margin-bottom: 4px;
  color: ${selectTheme('colors.neutral.80')};
`

const DocumentSubtitle = styled(Typography)`
  margin-left: 24px;
  font-size: 14px;
  font-weight: 300;
`

export { DocumentTitle, DocumentSubtitle }
